<template>
  <div class="collapse navbar-collapse navbar-ex1-collapse">
    <ul class="nav navbar-nav side-nav">
      <SectionSubMenu
        v-for="sectionLevel in sections.sectionLevels"
        :key="sectionLevel.name"
        :level="sectionLevel"
      />
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SectionSubMenu from './SectionSubMenu'

export default {
  components: {
    SectionSubMenu
  },
  created() {
    this.getSections()
  },
  computed: {
    ...mapGetters(['sections'])
  },
  methods: {
    getSections() {
      this.$store.dispatch('getSections')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SectionMenu.vue